/* eslint-disable react/no-danger */
import React, { useState } from 'react';

import Card from '../../elements/common/Card';
import useOnce from '../../hooks/useOnce';
import axios from '../../services/MyAxios';

export default function LotteryAbout({ url }: { url: string }) {
    const [title, setTitle] = useState('Lottery Description');
    const [text, setText] = useState('');

    useOnce(async () => {
        const response = await axios.get(url);
        setTitle(response.data.title);
        setText(response.data.text);
    });

    return text?.length ? (
        <Card title={title}>
            <div dangerouslySetInnerHTML={{ __html: text }} />
        </Card>
    ) : null;
}
